import {graphql, StaticQuery} from 'gatsby'
import React, {useCallback, useState} from 'react'
import Layout from '../components/layout'

export const siteMetadataQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
  }
`;

function LayoutContainer (props) {
  const [showNav, setShowNav] = useState(false);
  const handleShowNav = useCallback(() => {
    setShowNav(true)
  });
  const handleHideNav = useCallback(() => {
    setShowNav(false)
  });
  return (
    <StaticQuery
      query={siteMetadataQuery}
      render={data => {
        return (
          <Layout
            {...props}
            showNav={showNav}
            siteTitle={data.site.siteMetadata.title}
            onHideNav={handleHideNav}
            onShowNav={handleShowNav}
          />
        )
    }}
  />
  )
}

export default LayoutContainer
